export default __webpack_public_path__ + "static/media/613.82f4d66a.gif";